export default __webpack_public_path__ + "static/media/triangle.f8a4901b.svg";